'use strict';let

ClassExtensions=class ClassExtensions{
constructor(instance){
this._instance=instance;
}

defineLazyGetter(getterKey,fn,_mapper){
this._instance[`_lzl_${getterKey}`]={[getterKey]:1};
Object.defineProperty(this._instance,getterKey,{
get:()=>{
const _getterKey=this._instance[`_lzl_${getterKey}`];
if(_mapper.has(_getterKey)){
return _mapper.get(_getterKey);
}

const result=fn();
_mapper.set(_getterKey,result);
return result;
}});

}

defineLazyGetters(keyFnMap){
const propMap=new WeakMap;
for(const key in keyFnMap){
this.defineLazyGetter(key,keyFnMap[key],propMap);
}
}

static extend(instance){
return new ClassExtensions(instance);
}};


module.exports=ClassExtensions.extend;
//# sourceMappingURL=classExtensions.js.map
